import React from 'react';
import { headerNameHelper } from '../helpers/headerNameHelpers';

const ArticleTitle = ({ record }) => <span>{headerNameHelper(record, record.name)}</span>;

export default ArticleTitle;
